<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- บริษัท -->
              <v-select
                v-model="Company"
                :items="CompanyItem"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                @change="getDataBranch(Company)"
                hide-details
                label="บริษัท"
                class="ma-2"
              ></v-select>
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                hide-details
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                dense
                clearable
                clear-icon="mdi-close-circle"
                outlined
                hide-details
                label="แผนก"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-icon color="#871B12" size="30" @click="reloadData()"
                >mdi-calendar-search</v-icon
              >
              <v-icon color="#871B12" size="30" @click="clear()"
                >mdi-refresh</v-icon
              >
            </v-sheet>
          </v-col>
        </v-row>
        <v-row>
          <!-- data table -->
          <v-col cols="12">

            <v-card elevation="7" v-if="dataReady">
              <v-toolbar flat>
                <v-btn
                  :loading="!dataReady"
                  :disabled="!dataReady"
                  color="blue-grey"
                  class="white--text"
                  @click="exportData()"
                >
                  Download
                  <v-icon right dark> mdi-cloud-download </v-icon>
                </v-btn>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  v-model="searchAll"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>

              <v-card-title>
               ข้อมูลครอบครัว ยินยอมลงทะเบียน  ({{dataItem.length}})
              </v-card-title>

              <v-card-text>
                <v-data-table
                  v-model="selected"
                  :headers="columns"
                  :items="dataItem"
                  item-key="empCode"
                  class="elevation-1"
                  :search="searchAll"
                  :items-per-page="10"
                >
                </v-data-table>
              </v-card-text>

                 <v-card-title>
               พนักงาน ที่ยังไม่ได้ปรับปรุงข้อมูลครอบครัว  ({{dataItemEmpNotUpdateFamily.length}})
              </v-card-title>
                  <v-card-text>
                <v-data-table
                  v-model="selected"
                  :headers="columns2"
                  :items="dataItemEmpNotUpdateFamily"
                  item-key="empCode"
                  class="elevation-1"
                  :search="searchAll"
                  :items-per-page="10"
                >
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  data () {
    return {
      PK: '',
      path: '/event_punsuk/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'กิจกรรม',
          disabled: false
        },
        {
          text: 'ข้อมูลครอบครัว',
          disabled: true,
          href: '/HRM/Event/EventPunsukFamily'
        }
      ],
      // End Menu Config
      dataReady: true,
      BranchItem: [], // สาขา
      Branch: '', // สาขา
      DepartmentItem: [], // แผนก
      Department: '', // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      searchAll: '',
      session: this.$session.getAll(),
      columns: [
        { text: 'ชื่อพนักงาน', value: 'empFull_NameTH' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'เบอร์โทร', value: 'empTel' },
        { text: 'ชื่อ', value: 'familyFullName' },
        { text: 'อาชีพ', value: 'familyCareer' },
        { text: 'ความสัมพันธ์', value: 'familyStatus' },
        { text: 'รายได้', value: 'familySalary' },
        { text: 'อายุ', value: 'FamiliyAge' }
      ],
      columns2: [
        {
          text: 'รหัสพนักงาน',
          align: 'start',
          sortable: false,
          value: 'empCode'
        },
        { text: 'ชื่อพนักงาน', value: 'empFull_NameTH' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'เบอร์โทร', value: 'empTel' }
      ],
      dataItem: [],
      dataItemEmpNotUpdateFamily: []
    }
  },
  async mounted () {
    await this.getGetToken()
    this.dataReady = false
    this.reloadData()
    await this.getDataCompany()
    await this.getDataBranch()
    await this.getDataDepartment()
  },
  methods: {
    async reloadData () {
      await this.getData()
      await this.getDataEmpNotUpdateFamily()
    },
    async getData () {
      this.dataReady = true
      this.selected = []
      this.dataItem = []
      var Company = this.Company === '' ? '' : 'masCompanyName=' + this.Company
      var Branch = this.Branch === '' ? '' : '&masBranchName=' + this.Branch
      var Department =
        this.Department === '' ? '' : '&masDepartmentName=' + this.Department
      console.log(this.approveStatus)

      var url =
        this.DNS_IP +
        '/event_punsuk/getDataFamily?' +
        Company +
        Branch +
        Department
      const response = await axios
        .get(url, {
          headers: {
            'Application-Key': this.$session.getAll().ApplicationKey
          }
        })
        .catch(() => {
          this.dataReady = true
        })
      if (response.data) {
        this.dataItem = response.data
      }
    },
    async getDataEmpNotUpdateFamily () {
      this.dataReady = true
      // this.selected = []
      this.dataItemEmpNotUpdateFamily = []
      var Company = this.Company === '' ? '' : 'masCompanyName=' + this.Company
      var Branch = this.Branch === '' ? '' : '&masBranchName=' + this.Branch
      var Department =
      this.Department === '' ? '' : '&masDepartmentName=' + this.Department

      var url =
        this.DNS_IP +
        '/event_punsuk/getEmpNotUpdateFamily?' +
        Company +
        Branch +
        Department
      const response = await axios
        .get(url, {
          headers: {
            'Application-Key': this.$session.getAll().ApplicationKey
          }
        })
        .catch(() => {
          this.dataReady = true
        })
      if (response.data) {
        this.dataItemEmpNotUpdateFamily = response.data
      }
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(this.DNS_IP + '/master_company/getItem', {
          headers: {
            'Application-Key': this.$session.getAll().ApplicationKey
          }
        })
        .then(async (response) => {
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masCompanyName
            s.value = d.masCompanyName
            d = s
            this.CompanyItem.push(d)
          }
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(this.DNS_IP + '/master_branch/getItem', {
          headers: {
            'Application-Key': this.$session.getAll().ApplicationKey
          }
        })
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchName
            d = s
            this.BranchItem.push(d)
          }
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(this.DNS_IP + '/master_department/getItem', {
          headers: {
            'Application-Key': this.$session.getAll().ApplicationKey
          }
        })
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    },
    async clear () {
      this.Company = ''
      this.Branch = ''
      this.Department = ''
      await this.reloadData()
    },
    async exportData () {
      var dataItme = []

      var count = this.dataItem.length
      if (count > 0) {
        this.dataItem.forEach((element) => {
          let s = {
            'รหัสพนักงาน': element.empCode,
            'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
            'แผนก': element.masDepartmentName,
            'สาขา': element.masBranchName,
            'บริษัท': element.masCompanyName,
            'ความสัมพันธ์': element.familyStatus,
            'คำนำหน้า': element.familyTitleName,
            'ชื่อ': element.familyFirstName,
            'นามสกุล': element.familyLastName,
            'อายุ': element.FamiliyAge,
            'อาชีพ': element.familyCareer,
            'ที่อยู่/สถานที่ทำงาน': element.familyAddress,
            'เบอร์โทรศัพท์': element.familyTel,
            'เป็นผู้ติดต่อกรณีฉุกเฉิน': element.emergencyStatus,
            'อยู่กับครอบครัว': element.familyStayWithFamStatus,
            'ระดับการศึกษา': element.familyEducationLeavel,
            'สถานะมีชีวิต': element.familyAlive,
            'รายได้': element.familySalary
          }
          dataItme.push(s)
        })
        var wb = XLSX.utils.book_new() // make Workbook of Excel
        var data = XLSX.utils.json_to_sheet(dataItme)

        var dataItemEmpNotUpdateFamily = []
        this.dataItemEmpNotUpdateFamily.forEach(element => {
          let s = {
            'รหัสพนักงาน': element.empCode,
            'รหัสตำแหน่ง': element.positionCode,
            'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
            'ชื่อเล่น': element.empNickname,
            'วันเกิด': element.empBirthday,
            'อายุ': element.AGE,
            'เบอร์ติดต่อ': element.empTel,
            'Facebook': element.empFacebook,
            'LINE ID': element.empLineID,
            'ผู้ติดต่อฉุกเฉิน': element.empEmergencyName,
            'เบอร์ฉุกเฉิน': element.empEmergencyCall,
            'ตำแหน่งงาน': element.positionName,
            'ประเภทตำแหน่งงาน': element.positionTypeName,
            'แผนก': element.masDepartmentName,
            'สาขา': element.masBranchName,
            'บริษัท': element.masCompanyName,
            'วันที่เริ่มทำงาน': element.startDate,
            'อายุงาน': element.workDate,
            'USERLINEID': element.userLineuserId
          }
          dataItemEmpNotUpdateFamily.push(s)
        })
        var EmpNotUpdateFamily = XLSX.utils.json_to_sheet(dataItemEmpNotUpdateFamily)
        XLSX.utils.book_append_sheet(wb, data, 'รอการปรับปรุงเรียบร้อย') // sheetAName is name of Worksheet
        XLSX.utils.book_append_sheet(wb, EmpNotUpdateFamily, 'พนักงานรอการปรับปรุง') // sheetAName is name of Worksheet
        XLSX.writeFile(wb, 'ข้อมูลครอบครัวผู้ลงทะเบียน.xls') // name of the file is 'book.xlsx'
      } else {
        alert('ไม่พบข้อมูล')
      }
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Event/EventPunsukFamily.vue